<template>
    <div class="grid row posts-content">
        <div class="flex xs12 md12">
            <va-card>
                <va-card-content>
                    <a-breadcrumb>
                        <a-breadcrumb-item>
                            <router-link to="/admin/dashboard" tag="a"
                                >Home /
                            </router-link>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            <router-link to="/admin/forum/forumindex" tag="a"
                                >社区主页 /
                            </router-link>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item v-if="!isQA">
                            <router-link
                                to="/admin/forum/postsPage/index"
                                tag="a"
                                >{{ prevPage }} /
                            </router-link>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>我要发贴</a-breadcrumb-item>
                    </a-breadcrumb>
                    <div class="flex x12 md12 xs12">
                        <vxe-form
                            :data="toolbar.formData"
                            :rules="formRules"
                            @submit="publishPosts"
                        >
                            <vxe-form-item
                                title="板块"
                                field="plateVal"
                                :item-render="{}"
                                span="6"
                            >
                                <template #default="{ data }">
                                    <vxe-select
                                        v-model="data.plateVal"
                                        placeholder="请选择板块"
                                    >
                                        <vxe-option
                                            v-for="(item, index) in plateOption"
                                            :key="index"
                                            :value="item"
                                            :label="item.Name"
                                        >
                                        </vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                span="18"
                                title="标题"
                                field="postsTitle"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        clearable
                                        v-model="data.postsTitle"
                                        maxlength="200"
                                        placeholder="小伙伴们请注意：标题只能显示200个字哦！"
                                    >
                                    </vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="标签"
                                field="biaoqian"
                                :item-render="{}"
                                span="12"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        clearable
                                        v-model="data.biaoqian"
                                        style="display: none"
                                    >
                                    </vxe-input>
                                    <a-select
                                        mode="multiple"
                                        allowClear
                                        v-model:value="data.biaoqian"
                                        notFoundContent="暂无数据"
                                        optionLabelProp="label"
                                        placeholder="请选择选项"
                                        style="width: 100%"
                                        :options="
                                            options.map((item) => ({
                                                label: item.Name,
                                                value: item.ID,
                                            }))
                                        "
                                    >
                                    </a-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="分类"
                                field=""
                                :item-render="{}"
                                span="12"
                            >
                                <template #default="{ data }">
                                    <a-cascader
                                        :show-search="{ selectFilter }"
                                        v-model:value="data.fenlei2"
                                        @change="handleChange"
                                        style="width: 100%"
                                        placeholder="请选择分类"
                                        notFoundContent="暂无数据"
                                        :options="classOptions"
                                        change-on-select
                                        :fieldNames="{
                                            label: 'Name',
                                            value: 'ID',
                                            children: 'Children',
                                        }"
                                    />
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="24" :item-render="{}">
                                <template #default="">
                                    <div id="editor-wrapper">
                                        <!-- <QuillEditor ref="quill"  :modules="modules" toolbar="full"  /> -->
                                        <articleEditor
                                            v-model="articleContent"
                                        ></articleEditor>
                                    </div>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item style="padding: 0">
                                <template #default="{ data }">
                                    <div>
                                        <vxe-button
                                            status="primary"
                                            @click="insertEvent(false)"
                                            >选择文件</vxe-button
                                        >

                                        <span style="margin-left: 10px">{{
                                            data.fileUrlName
                                        }}</span
                                        ><span
                                            class="del-btn"
                                            v-if="data.fileUrlName != null"
                                            @click="delClick"
                                            >删除</span
                                        >
                                        <div
                                            style="display: inline-block"
                                            v-if="
                                                data.fileUrlName != null &&
                                                data.fileUrlName != '' &&
                                                isVideo
                                            "
                                        >
                                            是否播放：
                                            <vxe-select
                                                v-model="setStateValue"
                                                placeholder="请选择"
                                                style="margin-bottom: 20px"
                                            >
                                                <vxe-option
                                                    value="1"
                                                    label="是"
                                                ></vxe-option>
                                                <vxe-option
                                                    value="0"
                                                    label="否"
                                                ></vxe-option>
                                            </vxe-select>
                                        </div>
                                    </div>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #default="">
                                    <!-- <va-button class="flex xs14 msg-submit" :rounded="false" text-color="#ffffff">发布帖子</va-button> -->
                                    <vxe-button
                                        :loading="submitLoad"
                                        type="submit"
                                        class="msg-submit"
                                        status="primary"
                                        content="发布帖子"
                                    >
                                    </vxe-button>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                </va-card-content>
            </va-card>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref, reactive, getCurrentInstance } from "vue";
import { VXETable, VxeFormEvents, VxeFormPropTypes } from "vxe-table";
import articleEditor from "./components/articleEditor.vue";
import Qs from "qs";

export default {
    name: "publishArticle",
    components: { articleEditor },
    data() {
        const selectFilter = (inputValue, path) => {
            return path.some(
                (option) =>
                    option.label
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) > -1
            );
        };
        const { proxy } = getCurrentInstance();
        const options = proxy.$store.state.tabOptions,
            classOptions = proxy.$store.state.classOptions;
        const popupScroll = () => {
            console.log("popupScroll");
        };
        const toolbar = reactive({
            loading: false,
            formData: {
                postsTitle: "",
                searchStatus: "",
                plateVal: ref(),
                biaoqian: ref(),
                fenlei2: ref(),
                fileUrlName: null,
            },
        });
        const formRules = {
            plateVal: [{ required: true, message: "请选择分类" }],
            biaoqian: [
                { required: true, message: "请选择标签" },
                {
                    validator({ itemValue }) {
                        console.log(itemValue);
                        // 自定义校验
                        if (itemValue == undefined) {
                            return new Error("请选择标签");
                        }
                        if (itemValue.length == 0) {
                            return new Error("请选择标签");
                        }
                    },
                },
            ],
            fenlei2: [{ required: true, message: "请选择分类2" }],
            postsTitle: [{ required: true, message: "请填写标题" }],
            // contents: [{ required: true, message: '请填写内容' }]
        };
        const handleChange = (value) => {
            console.log(value);
        };
        return {
            setStateValue: "",
            selectFilter,
            handleChange,
            options,
            classOptions,
            formRules,
            toolbar,
            popupScroll,
            size: ref("default"),
            oneFile: null,
            isVideo: false,
            articleContent: null,
            pushEditorData: "",
            submitLoad: false,
            prevPage: "版块主页",
            isQA: false,
        };
    },
    mounted() {
        this.getForumSection();

        // this.$nextTick(function () {
        //     //富文本内容
        //     this.pushEditorData = null;
        // });
    },
    methods: {
        // getEditorContent(conetntHtml) {
        //     console.log(conetntHtml);
        //     //  console.log('conetntHtml')
        //     this.articleContent = conetntHtml;
        // },
        //删除附件
        delClick() {
            this.isVideo = false;
            this.oneFile = null;
            this.toolbar.formData.fileUrlName = null;
            this.setStateValue = "";
        },
        //获取板块选项
        getForumSection(paramData) {
            let resData,
                totalArticle = 0,
                totalReply = 0;
            const params = {
                Name: "",
            };
            this.$api.formsAPI
                .getForumSection(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    let arr = [
                        { value: "", Name: "全部板块", IsTab: "", ID: "" },
                    ];
                    resData = res.data.Data;
                    resData.map((item, index) => {
                        // console.log(item.ArticleCount)
                        totalArticle += Number(item.ArticleCount);
                        totalReply += Number(item.ReplyCount);
                    });
                    // this.plateOption = [...arr,...resData];
                    this.plateOption = resData;
                    this.totalArticle = totalArticle;
                    this.totalReply = totalReply;
                    // console.log(this.plateOption)

                    //获取数据记录
                    if (this.$store.state.forumPageData.sectionID != "") {
                        let postsParam = this.$store.state.forumPageData;
                        this.prevPage =
                            postsParam.sectionID == ""
                                ? "版块主页"
                                : postsParam.sectionName; //为空就是选的全部板块

                        // console.log(postsParam)
                        let plateFilter = this.plateOption.filter(
                            (item, index) => {
                                return postsParam.sectionID == item.ID;
                            }
                        );

                        this.toolbar.formData.plateVal = plateFilter[0]; //板块赋值
                    } else {
                        //是否从QA主页点击过来
                        this.isQA = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //发布帖子
        publishPosts() {
            this.submitLoad = true;

            // const quill = this.$refs.quill;
            // let quillHtml = quill.getHTML();
            // console.log(this.articleContent)
            if (this.setStateValue == "" && this.isVideo) {
                VXETable.modal.message({
                    content: "请选择附件是否可以播放字段！",
                    status: "warning",
                });
                this.submitLoad = false;
                return false;
            }
            if (this.articleContent == null || this.articleContent == "") {
                VXETable.modal.message({
                    content: "请填写内容！",
                    status: "warning",
                });
                this.submitLoad = false;
                return false;
            }
            const fenLeiVal = this.toolbar.formData.fenlei2;
            const fData = new FormData();
            // console.log(quillHtml)
            console.log(fenLeiVal);
            fData.append("ID", 0); //0 传0或不传
            fData.append("SectionID", this.toolbar.formData.plateVal.ID); //版块ID
            fData.append("Title", this.toolbar.formData.postsTitle); //标题
            fData.append("Contents", encodeURIComponent(this.articleContent)); //内容
            fData.append("Creator", this.$store.state.userID); //发帖人UID
            fData.append("IsPlay", this.isVideo ? this.setStateValue : 0); //可不传
            fData.append(
                "IsSys",
                this.$store.state.isAdmin == 1 ? this.$store.state.isAdmin : ""
            ); //1 系统管理员发布 0 非系统管理员发布
            fData.append(
                "CateID",
                fenLeiVal == undefined ? "" : fenLeiVal[fenLeiVal.length - 1]
            ); //类别ID只传一个选父级就传父级id，选子级就传子级id  this.toolbar.formData.fenlei2  == undefined ? '' : this.toolbar.formData.fenlei2.join(',')
            fData.append(
                "LabelID",
                this.toolbar.formData.biaoqian == undefined
                    ? ""
                    : this.toolbar.formData.biaoqian.join(",")
            ); //标签ID，多个用','隔开
            fData.append(
                "CateLabel",
                fenLeiVal == undefined ? "" : fenLeiVal.join(",")
            ); //类别ID列表
            // fData.append('FileName', this.toolbar.formData.fileUrlName);//不传
            fData.append("file", this.oneFile);
            this.$api.formsAPI
                .addForumArticleWithFile(fData)
                .then((res2) => {
                    if (res2.data.Success == false) {
                        VXETable.modal.alert({
                            content: res2.data.Message,
                            status: "error",
                        });
                        this.submitLoad = false;
                        return;
                    }
                    VXETable.modal.message({
                        content: "发布成功",
                        status: "success",
                    });
                    this.addUserCredit(2, res2.data);
                    this.submitLoad = false;
                    // console.log(res2)
                    this.delClick(); //重置数据
                    this.$router.push({ path: "/admin/forum/postsPage/index" });
                })
                .catch((error2) => {
                    VXETable.modal.alert({ content: error2, status: "error" });
                    this.submitLoad = false;
                    console.log(error2);
                });

            // VXETable.modal.message({ content: '发布成功！', status: 'success' })
        },
        //增加积分，2 发布 3 点赞 4 收藏
        addUserCredit(paramCode, creditdata) {
            let params = {
                ArticleID: creditdata.Data, //帖子ID
                UserID: this.$store.state.userID, //用户UID
                Type: paramCode,
            };
            this.$api.formsAPI
                .addUserCredit(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //选择文件
        async insertEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.toolbar.formData.fileUrlName = file.name;
                this.oneFile = file;
                this.getExtension(file.name);
            });
        },
        //验证是否视频格式
        getExtension(name) {
            if (name == null || name == "" || name == undefined) {
                return false;
            }
            let geshi = [
                    "avi",
                    "flv",
                    "mpg",
                    "mpeg",
                    "mpe",
                    "m1v",
                    "m2v",
                    "mpv2",
                    "mp2v",
                    "dat",
                    "ts",
                    "tp",
                    "tpr",
                    "pva",
                    "pss",
                    "mp4",
                    "m4v",
                    "wmv",
                    "swf",
                    "mp3",
                    "wma",
                    "mkv",
                    "m4p",
                    "m4b",
                    "3gp",
                    "3gpp",
                    "3g2",
                    "3gp2",
                    "ogg",
                    "mov",
                    "qt",
                    "amr",
                    "rm",
                    "ram",
                    "rmvb",
                    "rpm",
                ],
                mingzi = name.substring(name.lastIndexOf(".") + 1);
            for (let i = 0; i < geshi.length; i++) {
                if (geshi[i] == mingzi) {
                    this.isVideo = true;
                }
            }
            // console.log(this.isVideo)
        },
    },
};
</script>
<style src="./css/antd.css"></style>
<style scoped>
.del-btn {
    margin: 0 10px;

    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
}

::v-deep .ql-container {
    height: 200px;
}

.msg-submit {
    border-radius: unset;
    margin: 10px 0px 0px auto;
    display: block;
}
#editor-wrapper .w-e-full-screen-container {
    z-index: 99999 !important;
}
</style>
